import {
  BuyerUploadedRespondentListResponseDto,
  UploadRespondentListResponseDto,
} from '../dtos/respondent-list.dto';

export class RespondentListMapper {
  public fromUploadDto(dto: UploadRespondentListResponseDto): string[] {
    return dto.PSIDRef;
  }

  public fromUploadedListDto(
    dto: BuyerUploadedRespondentListResponseDto,
  ): string[] {
    return dto.psids.map((record) => record.PSID);
  }
}
